import { Button, Drawer, DrawerProps, message } from 'antd';
import PolicyForm, { PolicyFormProps } from './PolicyForm';
import { useTranslate } from '@tolgee/react';
import { noop } from 'lodash-es';
import { getMustacheExecuteContextV2 } from 'views/Aide/Scenario/PolicyForm';
import { createPolicy, updatePolicy } from './service';

export interface PolicyDrawerProps
  extends DrawerProps,
    Pick<PolicyFormProps, 'platform' | 'region' | 'initialValues' | 'policyList'> {
  onUpdated: () => Promise<any>;
}

function PolicyDrawer(props: PolicyDrawerProps) {
  const {
    platform,
    region,
    initialValues,
    policyList,
    onUpdated,
    onClose = noop,
    ...otherProps
  } = props;

  const { t } = useTranslate();

  const isCreate = !initialValues.fallbackPolicyId;

  return (
    <PolicyForm
      platform={platform}
      region={region}
      initialValues={initialValues}
      policyList={policyList}
      onSubmit={(values, helpers) => {
        const { fallbackPolicyId, priority, replyContent: slateReplyContent, ...others } = values;

        const replyContent = slateReplyContent
          .map(getMustacheExecuteContextV2)
          .map((_) => _.content);

        return (
          fallbackPolicyId && priority
            ? updatePolicy({
                fallbackPolicyId,
                priority,
                replyContent,
                ...others,
              })
            : createPolicy({
                replyContent,
                ...others,
              })
        )
          .then(() => onUpdated())
          .then(() => {
            onClose();

            message.success(t('operation.saveSucceed'));

            helpers.resetForm();
          })
          .catch(() => {
            message.error(t('operation.saveFailed'));
          });
      }}
    >
      {(form, props) => {
        const { isSubmitting, handleSubmit } = props;

        return (
          <Drawer
            width={1200}
            contentWrapperStyle={{ maxWidth: '100vw' }}
            bodyStyle={{ padding: '16px', background: '#F7F9FA' }}
            title={`${isCreate ? t('marketing.新增') : t('marketing.编辑')} ${t('aide.策略分支')}`}
            footer={
              <>
                <Button type="primary" loading={isSubmitting} onClick={() => handleSubmit()}>
                  {t('marketing.保存')}
                </Button>
                <Button onClick={onClose} style={{ marginLeft: '12px' }}>
                  {t('translation.取消')}
                </Button>
              </>
            }
            onClose={onClose}
            {...otherProps}
          >
            {form}
          </Drawer>
        );
      }}
    </PolicyForm>
  );
}

export default PolicyDrawer;
